import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=d9bb65a2&scoped=true"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"
import style0 from "./Submit.vue?vue&type=style&index=0&id=d9bb65a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bb65a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9bb65a2')) {
      api.createRecord('d9bb65a2', component.options)
    } else {
      api.reload('d9bb65a2', component.options)
    }
    module.hot.accept("./Submit.vue?vue&type=template&id=d9bb65a2&scoped=true", function () {
      api.rerender('d9bb65a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/investment-stategy-manager/Submit.vue"
export default component.exports